import { createSlice } from '@reduxjs/toolkit';
import { queueApi } from '../../services/queueApi';
import { QueuePanel } from '../../../types';

interface Queue {
    id: string;
    name: string;
}

interface QueueState {
    items: Queue[];
    loading: boolean;
    queueData: QueuePanel[]
}

const initialState: QueueState = {
    items: [],
    loading: false,
    queueData: [],
};

const queueSlice = createSlice({
    name: 'queue',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        builder.addMatcher(queueApi.endpoints.getQueuePanels.matchFulfilled,
            (state, { payload }) => ({
                ...state,
                queueData: payload,
            }));
        builder.addMatcher(queueApi.endpoints.getQueuePanelData.matchFulfilled,
            (state, { payload }) => ({
                ...state,
                queueStats: payload
            }))
    }
});

export const queue = queueSlice.reducer;
